/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import Select from 'react-select';

import { Row, Col } from 'reactstrap'

import {AppContext} from '../../AppContext';

class UserPermissions extends React.Component
{

  async componentDidMount()
  {
    let bodyData = {};
    bodyData.username = this.props.username;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getUserPermissions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving user permissions');
    let grantedPermissions = [];
    for (let x = 0; x < result.jsonData.userPermissions.length; x++)
      if ('Y' === result.jsonData.userPermissions[x].granted) grantedPermissions.push(result.jsonData.userPermissions[x]);

    this.setState({ permissions: result.jsonData.userPermissions, grantedPermissions: grantedPermissions });
  }

  constructor(props)
  {
    super();

    this.state =
    {
      permissions: [],
      grantedPermissions: []
    }

    this.onSelectChangeHandler = this.onSelectChangeHandler.bind(this);
  }

  async onSelectChangeHandler(grantedPermissions, actionMetaD)
  {
    this.setState({grantedPermissions: grantedPermissions});

    let bodyData = {};
    bodyData.username = this.props.username;

    let result = null;

    switch (actionMetaD.action)
    {
      case 'select-option':
        bodyData.permission = actionMetaD.option.permission;
        result = await this.context.dbTwig.callRestAPI('dgBunker', 'grantUserPermission', bodyData);
        break;

      case 'remove-value':
        bodyData.permission = actionMetaD.removedValue.permission;
        result = await this.context.dbTwig.callRestAPI('dgBunker', 'revokeUserPermission', bodyData);
        break;

      case 'clear':
        result = await this.context.dbTwig.callRestAPI('dgBunker', 'revokeAllPermissions', bodyData);
        break;

      default:
        return;
    }

    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing user permission');
    this.context.postNotification('info', 'Permissions changed.');
  }

  render()
  {
    return(
      <div>
        <Row style={{paddingTop: '10px'}}>
          <Col sm='2'>Granted Permissions</Col>
          <Col sm='4'>
            <Select value={this.state.grantedPermissions} options={this.state.permissions} onChange={this.onSelectChangeHandler} isMulti
              getOptionValue={option => option.permission} getOptionLabel={option => option.permission} 
              closeMenuOnSelect={false} placeholder={'Assign any needed permissions'} className="basic-multi-select" classNamePrefix="select"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

UserPermissions.contextType = AppContext;

export default UserPermissions